import { AccessLinkJsonResponse, AppendJsonResponse, DeliveredReturnsJsonResponse, EFileFormsJsonResponse, FetchReturnJsonResponse, InProcessReturnsJsonResponse, PartialUploadJsonResponse, RecognizeReturnRequestJsonResponse, RecycleBinReturnJsonResponse, SSR_ArchivedReturnAPI_archivedReturnsJsonResponse, SSR_ArchivedReturn_SignatureStatusJsonResponse, SSR_ArchivedReturn_SignerInformationJsonResponse, SignatureStatusJsonResponse, SignersInfoJsonResponse, UnRecognizedJsonResponse, UploadJsonResponse, UploadedReturnsJsonResponse } from "../../common/model/ssr/jsonResponse";
import { createCommonJsonResponse, createCommonJsonResponseWithData } from "../objectTypeConstants";

export const appendJsonResponse : AppendJsonResponse = {
    ...createCommonJsonResponse(200),
    data : {
        taxReturnId:"string"
    }
}

export const fetchReturnJsonResponse : FetchReturnJsonResponse = {
    ...createCommonJsonResponse(200),
    data : {
        taxReturnId : "string",
        taxYear : 0,
        clientId : "string",
        clientName: "string",
        signatureStatus: 0,
        engagementType: 0,
        isArchived : true,
        draftStatus: 0,
        groupName: "string"
    }
}

export const partialUploadJsonResponse : PartialUploadJsonResponse = {
    ...createCommonJsonResponse(200),
    data : {
        taxReturnId : "string"
    }
}

export const recognizeReturnRequestJsonResponse : RecognizeReturnRequestJsonResponse = {
    ...createCommonJsonResponse(202),
    data : {
        taxReturnId :"string"
    }
}

export const  unRecognizedReturnJsonResponse : UnRecognizedJsonResponse = {
    ...createCommonJsonResponse(200),
    data: [{
        rid : "string",
        clientId : "string",
        uploadedDate : "YYYY-MM-DDTHH:MM.SSSZ",
        taxSoftware : 0,
        taxReturnId : "string"
    }]
}

export const uploadJsonResponse : UploadJsonResponse = {
    ...createCommonJsonResponse(202),
    data : {
        taxReturnId: "string"
    }
}

export const uploadedReturnsJsonResponse : UploadedReturnsJsonResponse = {
    ...createCommonJsonResponse(200),
    data: [{
        rid : "string",
        clientId : "string",
        isRecognized : false,
        CreatedDate : "YYYY-MM-DDTHH:MM.SSSZ",
        RecognitionDate : "YYYY-MM-DDTHH:MM.SSSZ",
        taxSoftware : 0,
        delayRecognition : false,
        taxReturnId : "string"
    }]
}

export const inProcessReturnsJsonResponse : InProcessReturnsJsonResponse = {
    ...createCommonJsonResponse(200),
    data : [{
        documentStatus: 0,
        assignedToFirstName: "string",
        assignedToLastName : "string",
        eroSignerFirstName : "string",
        eroSignerLastName : "string",
        taxYear : 0,
        uploadedOn : "YYYY-MM-DDTHH:MM.SSSZ",
        engagementType : 0,
        taxSoftware : 0,
        clientId : "string",
        clientName : "string",
        locationId : 0,
        taxReturnId : "string",
        draftStatus : 0,
        groupName : "string"
    }]
}

export const recycleBinReturnJsonResponse : RecycleBinReturnJsonResponse = {
    ...createCommonJsonResponse(200),
     data : [{
         taxReturnId : "string",
         clientName : "string",
         clientId : "string",
         eroSignerFirstName : "string",
         eroSignerLastName : "string",
         engagementType : 0,
         taxYear : 0,
         deliveredOn : "YYYY-MM-DDTHH:MM.SSSZ",
         deliveredByFirstName : "string",
         deliveredByLastName : "string",
         deletedOn : "YYYY-MM-DDTHH:MM.SSSZ",
         deletedByFirstName : "string",
         deletedByLastName : "string",
         signatureStatus : 0,
         locationId : 0,
         groupName : "string"
    }]
}

export const accessLinkJsonResponse: AccessLinkJsonResponse = {
    ...createCommonJsonResponse(200),
    data: {
        clientId: "string",
        clientName: "string",
        taxYear: 0,
        signatureStatus: 0,
        accessLink: {
            taxpayer: "string",
            spouse: "string"
        }
    }
}

export const deliveredReturnsJsonResponse: DeliveredReturnsJsonResponse = {
    ...createCommonJsonResponse(200),
    data: [{
        taxYear: 0,
        taxSoftware: 0,
        clientName: "string",
        clientId: "string",
        eroSignerFirstName: "string",
        eroSignerLastName: "string",
        engagementType: 0,
        signatureStatus: 0,
        documentFilingType: 0,
        deliveredOn: "YYYY-MM-DDTHH:MM.SSSZ",
        lastReminderDate: "YYYY-MM-DDTHH:MM.SSSZ",
        downloadStatus: 0,
        locationId: 0,
        taxReturnId: "string",
        deletionDate: "YYYY-MM-DDTHH:MM.SSSZ",
        draftStatus : 0,
        groupName: "string"
    }]
}

export const eFileFormsJsonResponse: EFileFormsJsonResponse = {
    ...createCommonJsonResponse(200),
    data: {
        clientId: "string",
        clientName: "string",
        engagementType: 0,
        formNames: ["string"]
    }
}

export const signatureStatusJsonResponse: SignatureStatusJsonResponse = {
    ...createCommonJsonResponse(200),
    data: {
        signStatus: 0,
        documentStatus: 0,
        signMode: 0
    }
}

export const signersInfoJsonResponse: SignersInfoJsonResponse = {
    ...createCommonJsonResponse(200),
    data: [{
        documentId: 0,
        signer: "string",
        isSigned: false,
        signedOn: "string",
        signerType: 0,
        order: 0,
        name: "string",
        signerGuid: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        isDeceased: false
    }],
}


export const SSR_ArchivedReturn_getAccessLinkJsonResponse: AccessLinkJsonResponse = {
    ...createCommonJsonResponse(200),
    data: {
        clientId: "string",
        clientName: "string",
        taxYear: 0,
        signatureStatus: 0,
        accessLink: {
            taxpayer: "string",
            spouse: "string"
        }
    }
}
export const SSR_ArchivedReturn_archivedReturnsJsonResponse: SSR_ArchivedReturnAPI_archivedReturnsJsonResponse = {
    ...createCommonJsonResponseWithData(200),
    data: [{
        taxYear: 0,
        taxSoftware: 0,
        clientName: "string",
        clientId: "string",
        eroSignerFirstName: "string",
        eroSignerLastName: "string",
        engagementType: 0,
        signatureStatus: 0,
        documentFilingType: 0,
        deliveredOn: "2024-01-11T09:07:02.211Z",
        lastReminderDate: "2024-01-11T09:07:02.211Z",
        downloadStatus: 0,
        locationId: 0,
        taxReturnId: "string",
        deletionDate: "2024-01-11T09:07:02.211Z",
        groupName: "string"
    }]
}

export const SSR_ArchivedReturnAPI_SignatureStatusJsonResponse: SSR_ArchivedReturn_SignatureStatusJsonResponse = {
    ...createCommonJsonResponse(200),
    data: {
        signStatus: 0,
        documentStatus: 0,
        signMode: 0
    },
}

export const SSR_ArchivedReturnAPI_SignerInformationJsonResponse: SSR_ArchivedReturn_SignerInformationJsonResponse = {
    ...createCommonJsonResponse(200),
    data: [{
        documentId: 0,
        signer: "string",
        isSigned: false,
        signedOn: "string",
        signerType: 0,
        order: 0,
        name: "string",
        signerGuid: "string",
        isDeceased: false
    }],
}